import { type UseQueryOptions, useQuery } from "@tanstack/react-query";

import {
	getProductCatalogProducts,
	type ProductResponse,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import keys from "../keys";

export const useProductsQuery = (
	categoryCode: string | null | undefined,
	partnerCode: string | null | undefined,
	options?: Omit<UseQueryOptions<ProductResponse[]>, "queryKey" | "queryFn">,
) => {
	return useQuery({
		queryKey: keys.products(categoryCode, partnerCode),
		queryFn: processResponse(() =>
			getProductCatalogProducts(categoryCode, partnerCode),
		),
		...options,
	});
};
